module.exports = __webpack_public_path__ + "img/BLM.0de5f630.svg";